<template>
  <b-card>
    <portal-documentos-list
      ref="portalDocumentosList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="true"
      :tem-filtro-rapido="false"
      :show-botao-custom="true"
    >
      <template slot="show-botao-custom">
        <b-row>
          <b-col cols="5">
            <b-dropdown
              variant="outline-primary"
              size="sm"
              style="white-space: nowrap; height: 2.3rem;"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="SendIcon"
                  class="text-primary"
                  size="15"
                />
                Enviar por e-mail
              </template>
              <b-dropdown-item
                v-for="opcao in opcoesDestinatario"
                :key="opcao.value"
                @click="enviarEmailLoteGeral(opcao.value)"
              >
                {{ opcao.label }}
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col cols="7">
            <v-select
              id="baixaPortalSelect"
              :ref="`SelectFiltroDocs`"
              v-model="tipoDownload"
              v-b-tooltip.hover
              :options="opcoesBaixaEmLote"
              :clearable="true"
              label="nome"
              placeholder="Baixar documentos"
              style="font-size: 11px; width: 230px;"
              @input="baixaEmLoteGeral()"
            />
          </b-col>
        </b-row>
      </template>
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <b-badge
          v-if="props.column.field === 'rfbPgfn' ||
            props.column.field === 'situacaoFiscal' ||
            props.column.field === 'fgts' ||
            props.column.field === 'trabalhista' ||
            props.column.field === 'estadual' ||
            props.column.field === 'municipal'"
          :variant="getColorTag(props.row[props.column.field])"
          @click="openModalVisualizacaoArquivo(props.row, props.column.field)"
        >
          <span v-html="getDescricao(props.row[props.column.field])" />
        </b-badge>
      </template>
      <template slot="filtro-extra">
        <b-row>
          <b-col cols="6">
            <v-select
              :ref="`SelectFiltroDocs`"
              v-model="filtroString"
              v-b-tooltip.hover
              :options="filtrosRapidosDocs"
              :clearable="true"
              multiple
              deselect-from-dropdown
              :disabled="filtroCustom != null"
              placeholder="Tipos de documentos"
              @input="mudarDocSelecionado($event)"
            />
          </b-col>

          <b-col cols="6">
            <filtro-custom
              ref="filtroCustomModal"
              :api="apiPortal"
              :filtros-default-docs="filtrosDefaultDocs"
              @aplicarFiltro="aplicarFiltroCustom"
            />
          </b-col>

        </b-row>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          :api="apiPortal"
          @baixa-em-lote="baixaEmLoteLinha"
          @enviar-email="enviarEmailLinha($event.linha, $event.email)"
        />
      </template>
    </portal-documentos-list>
    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="'Enviando'"
    />
    <empresas-sem-email
      ref="empresaSemEmailList"
      v-model="empresasEmail"
      @salvar-email="salvarEmail($event)"
    />
  </b-card>
</template>

<style lang="scss">
.col-valores{
  white-space: nowrap;
}

[dir] #baixaPortalSelect .vs__dropdown-toggle{
  border-color: var(--primary) !important;
}
</style>

<script>

import vSelect from 'vue-select'
import api from './shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'PortalDocumentosView',
  components: {
    vSelect,
    PortalDocumentosList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('./shared/components/acoes/Acoes.vue'),
    FiltroCustom: () => import('@pilar/components/filtro-custom/FiltroCustom.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    EmpresasSemEmail: () => import('./shared/components/empresas-sem-email/EmpresasSemEmail.vue'),
  },
  data() {
    return {
      apiPortal: api,
      botoesOption: null,
      linha: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social',
        acaoClass: 'col-td-acao-2',
        disabledCheckbox: false,
        colunas: [
          { label: 'Razão social', field: 'razaoSocial', tdClass: 'tamanho-col-razaoSocial-portalDocumentos' },
          { label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'tamanho-col-cadastroFederal-portalDocumentos' },
          {
            label: 'Situação Fiscal',
            field: 'situacaoFiscal',
            tdClass: 'text-center',
            type: 'custom',
            visible: true,
          },
          {
            label: 'RFB/PGFN',
            field: 'rfbPgfn',
            tdClass: 'text-center',
            type: 'custom',
            visible: true,
          },
          {
            label: 'FGTS',
            field: 'fgts',
            tdClass: 'text-center',
            type: 'custom',
            visible: true,
          },
          {
            label: 'Trabalhista',
            field: 'trabalhista',
            tdClass: 'text-center',
            type: 'custom',
            visible: true,
          },
          // {
          //   label: 'MTE',
          //   field: 'mte',
          //   tdClass: 'text-center',
          //   type: 'custom',
          //   visible: true,
          // },
          {
            label: 'Estadual',
            field: 'estadual',
            tdClass: 'text-center',
            type: 'custom',
            visible: true,
          },
          {
            label: 'Municipal',
            field: 'municipal',
            tdClass: 'text-center',
            type: 'custom',
            visible: true,
          },
        ],
      },
      filtros: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      // filtrosDefaultDocs: ['Todos', 'Situação Fiscal', 'CND RFB/PGFN', 'CND FGTS', 'CND Trabalhista', 'CND MTE', 'CND Estadual', 'CND Municipal'],
      filtrosDefaultDocs: [],
      filtrosRapidosDocs: [],
      filtrosRapidos: [],
      filtroString: [],
      filtroCustom: null,
      criando: true,
      aplicando: false,
      filtroAtual: {},
      tipoDownload: null,
      opcoesBaixaEmLote: ['Arquivo Único', 'Por Empresa', 'Tipo de documento', 'Empresa e Tipo de documento'],
      isLoading: false,
      arrayColunas: ['situacaofiscal', 'rfbpgfn', 'fgts', 'trabalhista', 'estadual', 'municipal'],
      empresasEmail: [],
      opcoesDestinatario: [
        { value: 'principal', label: 'Apenas e-mail principal' },
        { value: 'adicional', label: 'Apenas e-mail adicional' },
        { value: 'ambos', label: 'Ambos os e-mails' },
      ],
    }
  },
  created() {
    this.montarColunasPermitidas()
    this.visualizacao.evento = this.carregar
    this.visualizacao.allpaged = this.allPaged
    this.tipoParcelamento = this.$route.meta.tipo
    this.filtrosRapidosDocs = this.filtrosDefaultDocs
    // this.carregarFiltro()
  },
  methods: {
    montarColunasPermitidas() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const acessos = userData.ability
      this.visualizacao.colunas.forEach(col => {
        const coluna = col.field.toLowerCase()
        if (!(coluna === 'razaosocial' || coluna === 'cadastrofederal')
        && !(coluna === 'situacaofiscal' && acessos.some(o => o.subject === 'situacaofiscal_federal'))
        && !(coluna === 'fgts' && acessos.some(o => o.subject === 'cnd_fgts'))
        && !(coluna === 'rfbpgfn' && acessos.some(o => o.subject === 'cnd_federal'))
        && !(coluna === 'trabalhista' && acessos.some(o => o.subject === 'cnd_trabalhista'))
        && !(coluna === 'estadual' && acessos.some(o => o.subject === 'cnd_estadual'))
        && !(coluna === 'municipal' && acessos.some(o => o.subject === 'cnd_municipal'))) {
          this.visualizacao.colunas = this.visualizacao.colunas.filter(obj => obj.field.toLowerCase() !== coluna)
        }
      })
      this.montarFiltrosDeDocumentos()
    },
    montarFiltrosDeDocumentos() {
      this.visualizacao.colunas.forEach(col => {
        const coluna = col.field.toLowerCase()
        if (coluna === 'situacaofiscal') {
          this.filtrosDefaultDocs.push('Situação Fiscal')
        } else if (coluna === 'rfbpgfn') {
          this.filtrosDefaultDocs.push('CND RFB/PGFN')
        } else if (coluna === 'fgts') {
          this.filtrosDefaultDocs.push('CND FGTS')
        } else if (coluna === 'trabalhista') {
          this.filtrosDefaultDocs.push('CND Trabalhista')
        } else if (coluna === 'estadual') {
          this.filtrosDefaultDocs.push('CND Estadual')
        } else if (coluna === 'municipal') {
          this.filtrosDefaultDocs.push('CND Municipal')
        }
        if (this.filtrosDefaultDocs.length === 5) {
          this.filtrosDefaultDocs.unshift('Todos')
        }
      })
    },
    aplicarFiltroCustom(filtroCustom) {
      this.filtroString = []
      this.filtroCustom = filtroCustom
      this.visibleColunas()
      this.$refs.portalDocumentosList.buscar()
    },
    mudarDocSelecionado(docs) {
      if (docs && docs.find(find => find === 'Todos')) {
        this.filtrosRapidosDocs = ['Todos']
        this.visibleColunas()
      } else {
        this.filtrosRapidosDocs = this.filtrosDefaultDocs
        this.visibleColunas()
      }
    },
    visibleColunas() {
      const filtroDocs = this.filtroString.length > 0 ? this.filtroString : this.filtroCustom?.filtrosDocs ?? []
      this.visualizacao.colunas.forEach(coluna => {
        if (filtroDocs.length > 0 && !filtroDocs.includes('Todos')) {
          if (!filtroDocs.some(s => s.replace('/', '').replace(' ', '').replace('ç', 'c').replace('ã', 'a')
            .toLowerCase()
            .includes(coluna.field.toLowerCase())) && this.arrayColunas.includes(coluna.field.toLowerCase())) {
            // eslint-disable-next-line
            coluna.visible = false
          } else {
            // eslint-disable-next-line
            coluna.visible = true
          }
        } else {
          if (filtroDocs.length > 0) {
            this.filtroString = ['Todos']
          }
          // eslint-disable-next-line no-param-reassign
          coluna.visible = true
        }
      })
    },
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro, this.filtroString, this.filtroCustom?.id ?? 0)
    },
    allPaged(filtro) {
      return api.getTodasLinhas(filtro, this.filtroString, this.filtroCustom?.id ?? '')
    },
    getColorTag(situacao) {
      if (situacao === 'EmAndamento') {
        return 'light-primary'
      }
      if (situacao === 'Ativa') {
        return 'light-success'
      }
      if (situacao === 'Retificada') {
        return 'light-warning'
      }
      if (situacao === 'Excluida') {
        return 'light-danger'
      }
      if (situacao === 'regular') {
        return 'light-success'
      }
      if (situacao === 'irregular') {
        return 'light-danger'
      }
      if (situacao === 'emmanutencao') {
        return 'light-warning'
      }
      if (situacao === 'motivo') {
        return 'light-dark'
      }
      return 'light-dark'
    },
    getDescricao(situacao) {
      if (situacao === 'motivo') {
        return 'Motivo'
      }
      if (situacao === 'regular') {
        return 'Regular'
      }
      if (situacao === 'empregadornaocadastrado') {
        return 'Empregador<br/>não cadastrado'
      }
      if (situacao === 'emmanutencao') {
        return 'Em manutenção'
      }
      if (situacao === 'irregular') {
        return 'Irregular'
      }
      return '-'
    },
    baixaEmLoteGeral() {
      let empresas = this.$refs.portalDocumentosList.linhaSelecionada
      let filtro = this.filtroString

      if (empresas === undefined || empresas.length === 0) {
        empresas = this.$refs.portalDocumentosList.gridInfo.dados.map(x => x.id)
      }

      if (filtro.length === 0 || filtro.includes('Todos')) {
        filtro = this.filtrosDefaultDocs
      }

      api.baixaEmLote('Portal Documentos', {
        Agrupamento: this.tipoDownload,
        Docs: filtro,
        Empresas: empresas,
        Filtro: this.filtroAtual,
        idFiltroCustom: this.filtroCustom?.id ?? 0,
        ValidarFiltroCustom: this.filtroCustom !== null || (this.$refs.portalDocumentosList.linhaSelecionada !== undefined && this.$refs.portalDocumentosList.linhaSelecionada.length > 0),
      }) // [16, 2]
      this.tipoDownload = null
    },
    /**
     * Envia e-mails em lote para as empresas selecionadas ou todas da grid.
     * @param {string} tipoDestinatario - Tipo de destinatário: 'principal', 'adicional' ou 'ambos'
     */
    enviarEmailLoteGeral(tipoDestinatario) {
      if (!this.filtroCustom && (!this.filtroString || this.filtroString.length > 0)) {
        this.$erro('Insira ao menos um Documento', 'danger')
      } else {
        let empresas = this.$refs.portalDocumentosList.enviarServidor.linhasSelecionadas

        this.isLoading = true
        if (!empresas) {
          empresas = this.$refs.portalDocumentosList.gridInfo.dados
        }
        const empresaEmail = empresas.map(empresa => ({ empresaId: empresa.id, emailsCC: null, email: empresa.email ? empresa.email : null }))

        api.enviarEmLote('Portal Documentos', {
          docs: this.filtroString,
          empresas: this.$refs.portalDocumentosList.linhaSelecionada,
          empresasEmail: [...empresaEmail],
          tipoDestinatario,
          idFiltroCustom: this.filtroCustom?.id ?? 0,
        }).then(payload => {
          this.isLoading = false
          if (payload.data.length > 0) {
            this.empresasEmail = payload.data

            this.$refs.empresaSemEmailList.show()
          }
          this.$sucesso('E-mails enviados com sucesso')
        }).catch(err => {
          this.isLoading = false
          this.$erro('Erro ao enviar os e-mails', 'danger')
          throw err
        })
      }
    },
    enviarEmailLinha(linha, email) {
      if (!this.filtroCustom && (!this.filtroString || this.filtroString.length > 0)) {
        this.$erro('Insira ao menos um Documento', 'danger')
      } else {
        this.isLoading = true

        const empresaEmail = {
          empresaId: linha.id,
          emailAdicionalEmpresa: email.emailsCc,
          email: email.emailsPara,
          mensagensAdicional: email.mensagensAdicional,
          definirEmailPadrao: email.definirEmailPadroes,
        }

        api.enviarEmLote('Portal Documentos', {
          docs: this.filtroString,
          empresasEmail: [empresaEmail],
          idFiltroCustom: this.filtroCustom?.id ?? 0,
        }).then(() => {
          this.isLoading = false
          this.$sucesso('E-mail enviado com sucesso')
        }).catch(err => {
          this.isLoading = false
          this.$erro('Erro ao enviar os e-mails', 'danger')
          throw err
        })
      }
    },
    baixaEmLoteLinha(empresaId) {
      let filtro = this.filtroString

      if (filtro.length === 0 || filtro.includes('Todos')) {
        filtro = this.filtrosDefaultDocs
      }
      api.baixaEmLote('Portal Documentos', { Docs: filtro, Empresas: [empresaId], idFiltroCustom: this.filtroCustom?.id ?? 0 })
    },
    salvarEmail(empresa) {
      this.$refs.portalDocumentosList.gridInfo.dados.find(find => find.id === empresa.id).email = empresa.email
      api.salvarEmail(empresa.id, empresa.email)
        .then(() => {
          this.enviarEmailLinha(empresa, { emailsPara: [empresa.email], emailsCc: [] })
        })
    },
  },

}
</script>
